/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-26 13:52:11
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-05-15 23:05:58
 * @FilePath: \hippo-web-admin\src\store\modules\user.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 登录状态管理
 */
import { formatMenus } from 'ele-admin';
import { getUserInfo, getUserDeviceInfo } from '@/api';
import { getFollowerUserInfo } from '@/api/doctor/index'
import customMenus from '@/config/menus';
import { getLoginType } from '@/utils/token-util';
import { BLOOD_SUGAR_UNIT } from '@/config/setting';

export default {
  namespaced: true,
  state: {
    alarmCount: 0,
    followerCount: 0,
    // 当前登录用户信息
    userInfo: null,
    // 当前登录用户的菜单
    menus: null,
    memberSetting: null, // 用户设置

    // 当前页面展示的用户信息
    showUserInfo: null,
    // 当前页面展示的用户设置
    showUserSetting: null,
  },
  mutations: {
    // 设置登录用户的信息
    setUserInfo(state, info) {
      state.alarmCount = 0
      state.followerCount = 0
      state.showUserInfo = info;
      state.showUserSetting = info.memberSeting;
    },
    // 设置用户的信息和设置
    setUserInfoAndSetting(state, info) {

      state.userInfo = info;
      state.memberSetting = info.memberSeting;
    },
    // 设置登录用户的菜单
    setMenus(state, menus) {
      state.menus = menus;
    },
    // 所有存储带有单位的数字改变
    changeUnit(state) {

    }
  },
  actions: {
    /**
     * 请求用户信息、菜单
     * @param commit
     * @returns {Promise}
     */
    fetchUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((result) => {
            console.log(result, 'result111')
            // 用户信息
            commit('setUserInfo', result.item.memberInfos[0]);
            // 设置当前网页的用户信息
            commit('setUserInfoAndSetting', result?.item?.memberInfos[0]);
            localStorage.setItem(BLOOD_SUGAR_UNIT, result?.item?.memberInfos[0]?.memberSeting?.unit || 'mmol/L');
            localStorage.setItem('TimeZone_byhippo', result?.item?.memberInfos[0]?.timeZone || 'Asia/Shanghai')
            // localStorage.setItem(BLOOD_SUGAR_UNIT, 'mg/dL');
            // 获取用户菜单并处理菜单数据格式
            const { menus, homePath } = formatMenus(customMenus[getLoginType() == '2' ? 'user' : 'follower']);
            commit('setMenus', menus);
            resolve({ menus, homePath });
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    /**
     * 修改信息之后，请求用户信息
     */
    fetchUserInfos({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((result) => {
            // 用户信息
            commit('setUserInfo', result.item.memberInfos[0]);
            resolve();
          })
          .catch((e) => {
            reject(e);
          });
      });
    },

    /**
     * follower 端查看信息获取关注用户的细腻
     */
    fetchFollowerUserInfo({ commit}, userId) {
      return new Promise((res, rej) => {
        getFollowerUserInfo({ memberId: userId }).then(result => {
          // 设置当前网页的用户信息
          commit('setUserInfoAndSetting', result?.item);
          res();
        })
        .catch((e) => {
          rej(e);
        });
      })
    }
  }
};
